import request from '@/utils/request'

export function getUserList(params) {
  return request({
    url: '/admin/user/list',
    method: 'get',
    params
  })
}

export function createUser(data) {
  return request({
    url: '/admin/user',
    method: 'post',
    data
  })
}

export function updateUser(data) {
  return request({
    url: '/admin/user',
    method: 'put',
    data
  })
}

export function deleteUser(id) {
  return request({
    url: '/admin/user/' + id,
    method: 'delete'
  })
}

export function getUserDetail(id) {
  return request({
    url: '/admin/user/' + id,
    method: 'get'
  })
}

// 管理端代改用户学校。不受「每年一次」限制，并会作废该用户的学生认证
export function updateUserSchool(id, data) {
  return request({
    url: '/admin/user/' + id + '/school',
    method: 'put',
    data
  })
}

export function resetUserPassword(id) {
  return request({
    url: '/admin/user/reset-password/' + id,
    method: 'put'
  })
}

// 封禁用户。data: { reason 必填, durationHours }；durationHours 为空或 <=0 = 永久封禁
export function banUser(id, data) {
  return request({
    url: '/admin/user/' + id + '/ban',
    method: 'put',
    data
  })
}

// 解封用户
export function unbanUser(id) {
  return request({
    url: '/admin/user/' + id + '/unban',
    method: 'put'
  })
}

export function getUserNotes(id, params) {
  return request({
    url: '/admin/user/' + id + '/notes',
    method: 'get',
    params
  })
}

export function getUserTakenNotes(id, params) {
  return request({
    url: '/admin/user/' + id + '/taken-notes',
    method: 'get',
    params
  })
}

export function getUserStatistics(id) {
  return request({
    url: '/admin/user/' + id + '/statistics',
    method: 'get'
  })
}

// 爱豆明细：与用户端「爱豆明细」同一张表、同一批数据，管理员可当场对账
export function getUserTransactions(id, params) {
  return request({
    url: '/admin/user/' + id + '/transactions',
    method: 'get',
    params
  })
}

export function getUserReferrals(id, params) {
  return request({
    url: '/admin/user/' + id + '/referrals',
    method: 'get',
    params
  })
}
